export default {
      id: "chevron-down-bondi-blue-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#chevron-down-bondi-blue",
      toString: function () {
        return this.url;
      }
    }